import React, { useState, useEffect } from 'react';

interface TimerProps {
    initialSeconds: number;
    onTimeUp: () => void;
    onTick: (secondsLeft: number) => void;
}

const Timer: React.FC<TimerProps> = ({ initialSeconds, onTimeUp, onTick }) => {
    const [seconds, setSeconds] = useState(initialSeconds);

    useEffect(() => {
        setSeconds(initialSeconds);
    }, [initialSeconds]);

    useEffect(() => {
        if (seconds <= 0) {
            onTimeUp();
            return;
        }

        const timerId = setInterval(() => {
            setSeconds(prevSeconds => {
                const newSeconds = prevSeconds - 1;
                onTick(newSeconds);
                return newSeconds;
            });
        }, 1000);

        return () => clearInterval(timerId);
    }, [seconds, onTimeUp, onTick]);

    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    
    const timeColor = seconds < 300 ? 'text-red-500' : 'text-green-400';

    return (
        <div className={`font-mono text-xl font-bold ${timeColor}`}>
            <i className="far fa-clock mr-2"></i>
            {String(minutes).padStart(2, '0')}:{String(remainingSeconds).padStart(2, '0')}
        </div>
    );
};

export default Timer;